import { Side } from '@floating-ui/react'
import { ReactNode } from 'react'

type Props = {
    children: ReactNode
    tooltipContent?: string | number | null
    showArrow?: boolean
    hidden?: boolean
    side?: Side
    noWrapText?: boolean
    /**
     * Turn off for dense grids where the pointer sweeps across many tooltips on its way somewhere else,
     * so each one waits the full delay instead of popping open as the pointer passes.
     */
    skipDelayWhileScanning?: boolean
}

/**
 * Timing belongs to the provider: 500ms before a tooltip opens, and a 200ms window after one closes in
 * which the next opens instantly, so scanning a toolbar doesn't cost a delay per icon. The delay itself is
 * not tunable per tooltip; only the skip can be turned off with `skipDelayWhileScanning`.
 *
 * The panel is `pointer-events-none`, so the pointer reaches whatever is underneath and nothing inside can
 * be clicked or selected. Text the user needs to copy goes in the page.
 */
export const AstraTooltip = ({
    children,
    showArrow = true,
    tooltipContent,
    hidden = false,
    noWrapText = false,
    side = 'top',
    skipDelayWhileScanning = true,
}: Props) => {
    if (hidden || !tooltipContent) {
        return <>{children}</>
    }

    return (
        <div
            className="contents"
            data-tooltip-provider="hero-tooltip-wrapper"
            data-tooltip-placement={side}
            data-tooltip-no-wrap-text={noWrapText}
            data-tooltip-show-arrow={showArrow}
            data-tooltip-skip-delay={skipDelayWhileScanning}
            data-tooltip={tooltipContent}
        >
            {children}
        </div>
    )
}
